// src/data/educationData.js
const educationData = [
  {
    title: "Fullstack Web Development",
    institution: "Neoland",
    date: "2025",
    description: "Bootcamp intensivo de desarrollo fullstack con React, Node.js, Express y MongoDB."
  },
  {
    title: "Bootcamp de Neoland de Web Development",
    institution: "Neoland",
    date: "Enero 2025 - Marzo 2025",
    description: "Frontend modular con React + Redux + Web Components y backend REST con Node.js, Express y MongoDB."
  },
  {
    title: "Curso intensivo en Programación (C, Algoritmos, Shell Scripting)",
    institution: "42 Madrid – Fundación Telefónica",
    date: "2024",
    description: "Resolución de problemas en C, algoritmos, estructuras de datos y shell scripting en entorno peer-to-peer."
  },
  {
    title: "Front-End Web Development Foundation Course",
    institution: "Aspasia",
    date: "Marzo 2024 - Junio 2024",
    description: "HTML, CSS, Flexbox, Bootstrap 5, Firebase (Auth + Firestore) y despliegue de sitios web responsivos."
  },
  {
    title: "Programación orientada a objetos y Bases de datos relacionales",
    institution: "IBM",
    date: "Septiembre 2023 - Marzo 2024",
    description: "Modelado y consultas SQL, ORM, frameworks y metodologías ágiles para desarrollo de software."
  },
  {
    title: "Web Development Bootcamp",
    institution: "Udemy",
    date: "2023",
    description: "Fundamentos de desarrollo web con HTML, CSS, JS y frameworks modernos."
  }
];

export default educationData;
